import Vue from 'vue'
import dayjs from 'dayjs'
import vuescroll from 'vuescroll'
import VueClipboard from 'vue-clipboard2'
import router from './router'
import store from './store'
import i18n from './i18n'
import axios from './axios'
import webSocket from './socket'
import utils from './utils'
import echarts from './echarts'
import './ui'

Vue.use(vuescroll, { ops: { bar: { background: 'rgba(144, 147, 153, 0.3)' } } })
Vue.use(VueClipboard)

Vue.prototype.$dayjs = dayjs
Vue.prototype.$axios = axios
Vue.prototype.$utils = utils
Vue.prototype.$echarts = echarts
webSocket(store)

export { router, store, i18n }
